import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';

import { queryClient } from '@/adapters/query';
import { crmScreenerApiClient } from '@/adapters/schemaClients';
import { CountActiveIntegrationEventsRequest } from '@/types/crm-screener-api';

export const INTEGRATION_EVENTS_COUNT_ACTIVE_QUERY_KEY =
  'countActiveIntegrationEvents';

export const invalidateIntegrationEventsCountActiveQuery = () => {
  queryClient.invalidateQueries([INTEGRATION_EVENTS_COUNT_ACTIVE_QUERY_KEY]);
};

export const useIntegrationEventsCountActiveQuery = (
  params: CountActiveIntegrationEventsRequest,
  options: UseQueryOptions<number, HTTPError> = {}
) => {
  return useQuery<number, HTTPError>(
    [INTEGRATION_EVENTS_COUNT_ACTIVE_QUERY_KEY, params],
    async () => {
      const response =
        await crmScreenerApiClient.countActiveIntegrationEvents(params);
      return response.data!;
    },
    options
  );
};
